if not App.angularApp?
    return

# Validates that date is in the past

App.angularApp.directive 'mfIsDateInPast', () ->
    return {
        require: 'ngModel'
        link: (scope, element, attrs, ngModel) =>
            ngModel.$validators.mfIsDateInPast = (modelValue, viewValue) =>
                if ngModel.$isEmpty(modelValue)
                    return true

                if moment().startOf('day').diff(viewValue, 'days', true) >= 0
                    return true

                return false
    }
